<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <div>
      <!-- <mrc_ess_iconGroup
        style="top: -50px"
        :is_disabled="disabled"
        :showEdit="hasBtn('edit-organizaiton-configuration')"
        :show_del="hasBtn('delete-organization-configuration')"
        @handleReturn="handleReturn"
        @handleEdit="handleEdit"
        @handleDel="handleDel"
      ></mrc_ess_iconGroup> -->
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6">
              <mrc_ess_multiText :readonly="disabled" :error-messages="$errors('params', 'smtp_server_host', maxLength(20))
                " v-model="params.smtp_server_host" noRequired style="width: 100%"
                :isNational="judegNational('smtp_server_host')" :label="$t('label_servehost')"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12" sm="6">
              <mrc_ess_multiText :readonly="disabled" noRequired :error-messages="$errors(
                'params',
                'smtp_server_port',
                between('1-65535').concat(integerRule)
              )
                " v-model="params.smtp_server_port" style="width: 100%" :isNational="judegNational('smtp_server_port')"
                :label="$t('label_serveport')"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12" sm="6">
              <mrc_ess_multiText :readonly="disabled" noRequired v-model="params.smtp_username" style="width: 100%"
                :isNational="judegNational('smtp_username')" :error-messages="$errors('params', 'smtp_username', maxLength(20))
                  " :label="$t('label_username')"></mrc_ess_multiText>
            </v-col>

            <v-col cols="12" sm="6">
              <mrc_ess_multiText :readonly="disabled" noRequired :error-messages="$errors('params', 'smtp_password', maxLength(20))
                " v-model="params.smtp_password" style="width: 100%" :isNational="judegNational('smtp_password')"
                :label="$t('label_password')"></mrc_ess_multiText>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
              <mrc_ess_dictName v-model="params.smtp_encryption" :placeholder="$t('label_encryption')"
                :disabled="disabled" :label="$t('label_encryption')" :rules="false" dict_name="smtp_encryption">
              </mrc_ess_dictName>
            </v-col>
            <v-col cols="12" sm="6">
              <mrc_ess_multiText :readonly="disabled" noRequired :error-messages="$errors(
                'params',
                'smtp_fromaddress',
                maxLength(20).concat(emailRule)
              )
                " v-model="params.smtp_fromaddress" style="width: 100%" :isNational="judegNational('smtp_fromaddress')"
                :label="$t('label_fromaddress')"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12" sm="6">
              <mrc_ess_multiText :readonly="disabled" noRequired v-model="params.smtp_fromadname" style="width: 100%"
                :isNational="judegNational('smtp_fromadname')" :label="$t('label_fromname')"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12" v-if="disabled">
              <h3 class="text-h5 text--secondary mb-6">
                {{ $t("label_test") }}
              </h3>
              <v-card>
                <v-card-text style="border: 1px solid #e0e0e0" class="d-flex align-center pa-6">
                  <!-- <div class="is_flex_around">
               
              </div> -->
                  <mrc_ess_input label="email" background-color="rgb(245, 245, 245)" :readonly="false" v-model="emailNum"
                    :placeholder="$t(
                      'label_Enter_the_email_address_to_test_whether_the_email_is_received'
                    )
                      "></mrc_ess_input>
                  <v-btn rounded :disabled="false" color="grey darken-2" class="ml-4" @click="send_mail"
                    style="color: #fff">{{ $t("label_send") }}</v-btn>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <mrc_ess_submitBtn @cancel="cancel" v-if="!disabled" :loading="loading" @success="success"></mrc_ess_submitBtn>
      </v-card>
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  required,
  maxLength,
  between,
  email,
  url,
  integer,
} from "vuelidate/lib/validators";
import {
  mail_update_add,
  mail_del,
  mail_info,
  sendMail,
  get_company_del,
} from "@/service/api/company_set";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      emailNum: "",
      skLoading: true,
      params: {
        uuid: "",
        org_level_uuid: "", // 必填
        smtp_server_host: "", //服务器
        smtp_server_port: "", // 端口
        smtp_username: "", // 邮箱用户名
        smtp_license_code: "", // 邮箱第三方授权码
        smtp_password: "", //	发件人邮箱密码
        smtp_encryption: "", //加密方式
        smtp_fromaddress: "", // 发件人邮箱地址
        smtp_fromadname: "", //客户端类型(web,app)
      },
    };
  },
  validations: {
    params: {
      smtp_server_host: {
        maxLength: maxLength(20),
      },
      smtp_server_port: {
        integer,
        between: between(1, 65535),
      },
      smtp_username: {
        maxLength: maxLength(20),
      },
      smtp_password: {
        maxLength: maxLength(20),
      },
      smtp_fromaddress: {
        email,
        maxLength: maxLength(20),
      },
    },
  },
  created() { },
  async mounted() {
    await this.national("mrbase_sys_company_email_smtp");
    this.skLoading = true;
    this.params.org_level_uuid = this.$store.state.uuid;
    await this.getInfo();
    this.skLoading = false;
  },
  methods: {
    async send_mail() {
      const res = await sendMail({
        user_account: this.emailNum,
        mailTempName: "",
        attachment: "",
        fseData: {
          language_code: "",
          content_type: "",
          content: "",
        },
      });
    },
    async getInfo() {
      const info = await mail_info({
        org_level_uuid: this.params.org_level_uuid,
      });
      if (info.code == 200 && Object.keys(info.data).length > 0) {
        this.params = info.data;
      }
    },
    cancel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
      })
        .then(async () => {
          await this.getInfo();
          // this.disabled = !this.disabled

          this.$emit("cancel", !this.disabled);
          // this.$router.push({
          //   name: 'enterprise'
          // })
        })
        .catch(() => { });
    },
    async success() {
      this.loading = true;
      const mail = await mail_update_add({
        uuid: this.params.uuid,
        org_level_uuid: this.params.org_level_uuid, // 必填
        smtp_server_host: this.params.smtp_server_host,
        smtp_server_port: this.params.smtp_server_port,
        smtp_username: this.params.smtp_username,
        smtp_license_code: this.params.smtp_license_code,
        smtp_password: this.params.smtp_password,
        smtp_encryption: this.params.smtp_encryption,
        smtp_fromaddress: this.params.smtp_fromaddress,
        smtp_fromadname: this.params.smtp_fromadname,
      });
      if (mail.code == 200) {
        this.params.uuid = mail.data.uuid;
        // this.$store.commit(
        //   'newsTips',
        //   this.$t('message_The_submission_was_successful')
        // )
        this.$Message({
          text: this.$t("message_The_submission_was_successful"),
        });
        this.disabled = !this.disabled;
      }
      this.loading = false;
    },
    handleReturn() {
      this.$router.go(-1);
    },
    handleEdit() {
      this.disabled = !this.disabled;
    },
    // 删除
    handleDel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      })
        .then(async () => {
          const del = await get_company_del({
            uuid: this.$store.state.listObj.uuid,
          });
          if (del.code == 200) {
            this.delData(this.$store.state.listObj.uuid);
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
            if (
              this.$store.state.userData.userType != 1 &&
              this.$store.state.userData.userType != 4
            ) {
              await this.$store.dispatch("set_topcompanylist");
            }
            this.$router.push({
              name: "enterprise",
            });
          }
        })
        .catch(() => { });
      // this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') })
      //   .then(async () => {
      //     const del = await mail_del({
      //       org_level_uuid: this.params.org_level_uuid,
      //     })
      //     if (del.code == 200) {
      //       this.$Message({
      //         text: this.$t('message_The_deletion_was_successful'),
      //       })
      //       this.$router.go(-1)
      //     }
      //   })
      //   .catch(() => { })
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped></style>
